import React, { createContext, useState, useEffect, useContext } from "react";
import { ConfigContext } from "../security/ConfigContext";
import useAxios from "../adapter/useAxios";
import useSecurity from "../hooks/useSecurity";
import _ from "lodash";
import LoadingSpinner from "../components/common/LoadingSpinner";
import { UserContext } from "./UserContext";

const initialState = {
  loading: true,
  lists: [],
  selectedList: "",
  newItem: "",
  itemList: [],
  _setSelectedList: (_value) => {},
  _setNewItem: (_value) => {},
  onAddItem: () => {},
  deleteItem: (_name, _id) => {},
  onUpdateItem: (_item) => {},
  message: "",
  _setMessage: (_msg) => {},
};

export const AdminContext = createContext(initialState);
AdminContext.displayName = "AdminContext";

export const AdminContextProvider = ({ children }) => {
  const [config] = useContext(ConfigContext);
  const [loading, setLoading] = useState(initialState.loading);
  const { isAuthenticated, getAccessToken } = useSecurity();
  const [lists, setList] = useState(initialState.lists);
  const [selectedList, setSelectedList] = useState(initialState.selectedList);
  const [newItem, setNewItem] = useState(initialState.newItem);
  const [itemList, setItemList] = useState(initialState.itemList);
  const [message, setMessage] = useState(initialState.message);
  const {get, post, deleteReq} = useAxios(); 
  const { isUserLoading } = useContext(UserContext);
  
  const _setSelectedList = (value) => {
    setSelectedList(value);
    let filteredList = _.get(lists, value, []);
    setItemList(_.uniq(filteredList));
  };
  const _setNewItem = (value) => {
    setNewItem(value);
  };
  const _setMessage = (msg) => {
    setMessage(msg);
  };

  const fetchData = () => {
      get({
        url: config.apiUrls.referenceData
      })
        .then((response) => {
            let groupResponse = _.groupBy(response, "listName");
            setList(groupResponse);            
            if (_.isEmpty(selectedList)) {
              setSelectedList(_.get(response[0], "listName"));
              setItemList(_.uniq(_.get(groupResponse, response[0].listName, [])));
            } else {
              setItemList(_.uniq(_.get(groupResponse, selectedList, [])));
            }          
        })
        .catch((error) => console.log(error))
        .finally(() =>  setLoading(false))
  };

  const deleteItem = (name, id) => {
    if (_.isEmpty(id) && _.isEmpty(name)) {
      return;
    }
    setLoading(true);
    deleteReq({
      url: config.apiUrls.referenceData + "/" + selectedList + "/" + id
    })
    .then((response) => {
      console.log(response);
      setMessage(name + " was removed from " + selectedList);
      fetchData();
    })
    .catch((error) => console.log(error))
    .finally(() => setLoading(false))
  };

  const onAddItem = () => {
    if (_.isEmpty(newItem)) {
      return;
    }
    let addItem = {};    
    try {
      addItem["listName"] = itemList[0].listName;
      addItem["name"] = newItem;
      addItem["listDesc"] = itemList[0].listDesc;
    } catch (e) {}
    if (_.isEmpty(addItem)) {
      return;
    }
    setLoading(true);
    post({
      url:  config.apiUrls.referenceData + "/" + selectedList,
      data: addItem
    })
    .then((response) => {
      setMessage(_.get(response, "name") + " saved");
      console.log("response-",response)
      setNewItem("");
      fetchData();
    })
    .catch((error) => console.log(error))
    .finally(() => setLoading(false))
  };
  const onUpdateItem = (item) => {
    if (_.isEmpty(item)) {
      return;
    }
    setLoading(true);
    post({
      url: config.apiUrls.referenceData + "/" + selectedList,
      data : item
    })
    .then((response) => {
      setMessage(_.get(response, "name") + " saved");
      fetchData();
    })
    .catch((error) => console.log(error))
    .finally(() => setLoading(false))
  };

  useEffect(() => {
    setLoading(true);
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, getAccessToken]);

  return (
    <AdminContext.Provider
      value={{
        loading,
        lists,
        selectedList,
        newItem,
        itemList,
        _setSelectedList,
        _setNewItem,
        onAddItem,
        deleteItem,
        onUpdateItem,
        message,
        _setMessage,
      }}>
      {children}
      <LoadingSpinner show={loading || isUserLoading} />
    </AdminContext.Provider>
  );
};
